<template>
  <div id="welcome-footer">
    <div id="line-bottom" :class="{ animate: animate }"></div>
    <div class="container">
      <div class="left">
        <!-- <button>password</button>
        <button @click="onMuteClick">
          {{ mute ? "mute" : "unmute" }}
        </button> -->
      </div>
      <h1>Independent Contractor</h1>
      <div class="right">
        <!-- <button>about</button> -->
      </div>
    </div>
  </div>
</template>

<script>
import gameStateStore from "@/stores/GameStateStore";

export default {
  name: "LoginOverlayFooter",
  data() {
    return {
      animate: false,
    };
  },
  computed: {
    mute() {
      return gameStateStore.mute;
    },
  },
  methods: {
    onMuteClick() {
      gameStateStore.mute = !gameStateStore.mute;
    },
  },
  mounted() {
    if (document.hidden) {
      // https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
      document.addEventListener("visibilitychange", () => {
        if (!document.hidden) {
          this.animate = true;
        }
      });
    } else {
      setTimeout(() => {
        this.animate = true;
      }, 1);
    }
  },
};
</script>

<style lang="scss">
@import "@/assets/variables";

#welcome-footer {
  width: 100%;
  #line-bottom {
    width: 100%;
    height: 25px;
    background-color: $accent;

    transition-property: transform;
    transition-duration: 0.9s;
    transition-timing-function: ease-in-out;

    transform-origin: right;
    transform: scaleX(0);

    &.animate {
      transform: scaleX(1);
    }
  }

  .container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .left {
      flex: 1;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
    }

    .right {
      flex: 1;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
    }
  }

  button {
    border: none;
    padding: 0px;
    margin-left: 8px;
    margin-right: 8px;
    padding-top: 8px;
    padding-bottom: 8px;
    font-size: 1.8em;
    font-weight: bold;
    color: $primary-text-black;
    cursor: pointer;
  }
}
</style>
